import { type UserStatus } from 'next-auth'

export const isUserAuthenticated = (status: UserStatus) => {
  return status === 'authenticated'
}

export const isUserSessionLoading = (status: UserStatus) => {
  return status === 'loading'
}
